<div class="section">
  <div ngbAccordion class="ngb-accordion-default contextbar-accordion">
    <div ngbAccordionItem [collapsed]="collapsed()" (shown)="onExpand()" (hidden)="onCollapse()">
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <span>
            <b>{{ title }}</b>
            <qpoint-icon class="contextbar-icon" icon="{{ isPanelOpen ? 'angle-up' : 'angle-down'}}"></qpoint-icon>
          </span>
        </button>
      </div>
      <div ngbAccordionCollapse>
       <div ngbAccordionBody>
        <ng-template>
          <ng-content></ng-content>
        </ng-template>
       </div> 
      </div>
    </div>
  </div>
</div>
